import type { MeasurementUnit } from './units'

const METERS_PER_CENTIMETER = 0.01
const METERS_PER_FOOT = 0.3048
const METERS_PER_INCH = 0.0254
const KILOGRAMS_PER_POUND = 0.45359237
const SECONDS_PER_MINUTE = 60

type UnitScale = {
  quantity: 'length' | 'speed' | 'mass'
  baseUnitsPerUnit: number
}

const UNIT_SCALES: Readonly<Record<string, UnitScale | null>> = {
  m: { quantity: 'length', baseUnitsPerUnit: 1 },
  meters: { quantity: 'length', baseUnitsPerUnit: 1 },
  cm: { quantity: 'length', baseUnitsPerUnit: METERS_PER_CENTIMETER },
  feet: { quantity: 'length', baseUnitsPerUnit: METERS_PER_FOOT },
  inches: { quantity: 'length', baseUnitsPerUnit: METERS_PER_INCH },
  inch: { quantity: 'length', baseUnitsPerUnit: METERS_PER_INCH },
  'm/s': { quantity: 'speed', baseUnitsPerUnit: 1 },
  'cm/s': { quantity: 'speed', baseUnitsPerUnit: METERS_PER_CENTIMETER },
  'm/min': { quantity: 'speed', baseUnitsPerUnit: 1 / SECONDS_PER_MINUTE },
  'feet/s': { quantity: 'speed', baseUnitsPerUnit: METERS_PER_FOOT },
  'inches/s': { quantity: 'speed', baseUnitsPerUnit: METERS_PER_INCH },
  'feet/min': { quantity: 'speed', baseUnitsPerUnit: METERS_PER_FOOT / SECONDS_PER_MINUTE },
  kg: { quantity: 'mass', baseUnitsPerUnit: 1 },
  pounds: { quantity: 'mass', baseUnitsPerUnit: KILOGRAMS_PER_POUND },
  seconds: null,
  sec: null,
  count: null,
  repetitions: null,
  degrees: null,
  'degrees/sec': null,
  '%': null,
  ratio: null,
  'steps/min': null,
  'stairs/min': null,
  '(m/s^2)^2': null,
  '(m/s^2)^3': null,
} satisfies Record<MeasurementUnit, UnitScale | null>

const scaleOf = (unit: string | null | undefined): UnitScale | null | undefined => (unit ? UNIT_SCALES[unit] : null)

export const convertUnit = (
  value: number,
  fromUnit: string | null | undefined,
  toUnit: string | null | undefined,
): number => {
  const from = scaleOf(fromUnit)
  const to = scaleOf(toUnit)
  return from && to && from.quantity === to.quantity ? value * (from.baseUnitsPerUnit / to.baseUnitsPerUnit) : value
}
